exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntbody[data-v-9b8d4040] {\n  border-top: none !important;\n}\n", ""]);

// exports
